import { EVENT_KIND_OPTIONS } from "@libs/utils";
import { z } from "zod";

export const eventKindSchema = z.enum(EVENT_KIND_OPTIONS);
